<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="calendar" />แผนการดำเนินงาน
    </h6>

    <div class="event-list">
      <div v-for="(task, index) in value" :key="index" class="event-list-item">
        <div class="row">
          <div class="col-12">
            <h6>กิจกรรมที่ {{ index + 1 }}</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-1">
            <strong>กิจกรรม</strong>
          </div>
          <div class="col-11">
            <span>{{ value[index].title }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-1">
            <strong>ช่วงเวลา</strong>
          </div>
          <div class="col-5">
            {{ formatDate(value[index].datetime.start) }} - {{ formatDate(value[index].datetime.end) }}
          </div>
          <div class="col-2 text-right">
            <strong>ผู้รับผิดชอบ</strong>
          </div>
          <div class="col-4">
            {{ value[index].responsiblePerson }}
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: { type: Array, required: true }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('D/M/Y')
    }
  }
}
</script>

<style scoped lang="scss">
.event-list {
  padding: $card-spacer-x;
}

.event-list-item {
  margin: -$card-spacer-x;
  padding: $card-spacer-x;
  border-bottom: 1px dashed $gray-300;
  margin-bottom: 20px;
}
</style>
